export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	bulbasaur: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ivysaur: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	venusaur: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	charmander: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	charmeleon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	charizard: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	squirtle: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	wartortle: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	blastoise: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	caterpie: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	metapod: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	butterfree: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	weedle: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	kakuna: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	beedrill: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	pidgey: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	pidgeotto: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	pidgeot: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	rattata: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	raticate: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	spearow: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	fearow: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ekans: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	arbok: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		tier: "NU",
	},
	raichu: {
		tier: "UU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		tier: "UU",
	},
	nidoranf: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	nidorina: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	nidoqueen: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	nidoranm: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	nidorino: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	nidoking: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	cleffa: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	clefairy: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	clefable: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		tier: "UU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "PU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NU",
	},
	crobat: {
		tier: "UUBL",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "ZU",
	},
	vileplume: {
		tier: "UU",
	},
	bellossom: {
		tier: "NU",
	},
	paras: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	parasect: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	venonat: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	venomoth: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	diglett: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	dugtrio: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	meowth: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	persian: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "UU",
	},
	mankey: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	primeape: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	growlithe: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	arcanine: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	poliwag: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	poliwhirl: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	poliwrath: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	politoed: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	abra: {
		tier: "PU",
	},
	kadabra: {
		tier: "UUBL",
	},
	alakazam: {
		tier: "UUBL",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "PUBL",
	},
	machamp: {
		tier: "UUBL",
	},
	bellsprout: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	weepinbell: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	victreebel: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	tentacool: {
		tier: "ZU",
	},
	tentacruel: {
		tier: "UU",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "ZU",
	},
	golem: {
		tier: "UU",
	},
	ponyta: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	rapidash: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	slowpoke: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	slowbro: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	slowking: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	magnemite: {
		tier: "ZU",
	},
	magneton: {
		tier: "OU",
	},
	farfetchd: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	doduo: {
		tier: "ZU",
	},
	dodrio: {
		tier: "UUBL",
	},
	seel: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	dewgong: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	grimer: {
		tier: "ZU",
	},
	muk: {
		tier: "UU",
	},
	shellder: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	cloyster: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	gastly: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	haunter: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	gengar: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	onix: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	steelix: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	drowzee: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	hypno: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	krabby: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	kingler: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	voltorb: {
		tier: "ZU",
	},
	electrode: {
		tier: "UU",
	},
	exeggcute: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	exeggutor: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	cubone: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	marowak: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	tyrogue: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	hitmonlee: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	hitmonchan: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	hitmontop: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	lickitung: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	koffing: {
		tier: "ZU",
	},
	weezing: {
		tier: "UUBL",
	},
	rhyhorn: {
		tier: "ZU",
	},
	rhydon: {
		tier: "UUBL",
	},
	chansey: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	blissey: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	tangela: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	kangaskhan: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	horsea: {
		tier: "ZU",
	},
	seadra: {
		tier: "PU",
	},
	kingdra: {
		tier: "UUBL",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "ZU",
	},
	staryu: {
		tier: "ZU",
	},
	starmie: {
		tier: "OU",
	},
	mrmime: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	scyther: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	scizor: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	smoochum: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	jynx: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	elekid: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	electabuzz: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	magby: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	magmar: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	pinsir: {
		tier: "UU",
	},
	tauros: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "OU",
	},
	lapras: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ditto: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	eevee: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	vaporeon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	jolteon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	flareon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	espeon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	umbreon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	porygon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	porygon2: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	omanyte: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	omastar: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	kabuto: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	kabutops: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	aerodactyl: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	snorlax: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	articuno: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	zapdos: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	moltres: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	dratini: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	dragonair: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	dragonite: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	mewtwo: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	mew: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	chikorita: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	bayleef: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	meganium: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	cyndaquil: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	quilava: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	typhlosion: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	totodile: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	croconaw: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	feraligatr: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	sentret: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	furret: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	hoothoot: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	noctowl: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ledyba: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ledian: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	spinarak: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ariados: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	chinchou: {
		tier: "PU",
	},
	lanturn: {
		tier: "UU",
	},
	togepi: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	togetic: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		tier: "UU",
	},
	mareep: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	flaaffy: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ampharos: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		tier: "UU",
	},
	sudowoodo: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	hoppip: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	skiploom: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	jumpluff: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	aipom: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	sunkern: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	sunflora: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	yanma: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	wooper: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	quagsire: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	murkrow: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	misdreavus: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	unown: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	wynaut: {
		tier: "Uber",
	},
	wobbuffet: {
		tier: "Uber",
	},
	girafarig: {
		tier: "UU",
	},
	pineco: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	forretress: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	dunsparce: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	gligar: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	snubbull: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	granbull: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	qwilfish: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	shuckle: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	heracross: {
		tier: "OU",
	},
	sneasel: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	teddiursa: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ursaring: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		tier: "PU",
	},
	swinub: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	piloswine: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	corsola: {
		tier: "ZUBL",
	},
	remoraid: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	octillery: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	delibird: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	mantine: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	skarmory: {
		tier: "OU",
	},
	houndour: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	houndoom: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "UUBL",
	},
	stantler: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	smeargle: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	miltank: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	raikou: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	entei: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	suicune: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	larvitar: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	pupitar: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	tyranitar: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	lugia: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	hooh: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	celebi: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "PU",
	},
	sceptile: {
		tier: "UUBL",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "PU",
	},
	blaziken: {
		tier: "UUBL",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "PU",
	},
	swampert: {
		tier: "OU",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		tier: "PU",
	},
	zigzagoon: {
		tier: "NFE",
	},
	linoone: {
		tier: "UUBL",
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		tier: "ZU",
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		tier: "ZU",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "ZU",
	},
	ludicolo: {
		tier: "UUBL",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		tier: "UU",
	},
	taillow: {
		tier: "ZU",
	},
	swellow: {
		tier: "UUBL",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		tier: "NU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		tier: "UUBL",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		tier: "ZU",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		tier: "OU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		tier: "NU",
	},
	slaking: {
		tier: "UUBL",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		tier: "UU",
	},
	shedinja: {
		tier: "ZUBL",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		tier: "UU",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		tier: "UUBL",
	},
	nosepass: {
		tier: "ZU",
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		tier: "ZU",
	},
	sableye: {
		tier: "NU",
	},
	mawile: {
		tier: "PU",
	},
	aron: {
		tier: "ZU",
	},
	lairon: {
		tier: "ZUBL",
	},
	aggron: {
		tier: "UU",
	},
	meditite: {
		tier: "ZU",
	},
	medicham: {
		tier: "UUBL",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		tier: "UU",
	},
	plusle: {
		tier: "NU",
	},
	minun: {
		tier: "PU",
	},
	volbeat: {
		tier: "ZU",
	},
	illumise: {
		tier: "ZU",
	},
	roselia: {
		tier: "NU",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		tier: "PU",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		tier: "UU",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		tier: "NU",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		tier: "UU",
	},
	torkoal: {
		tier: "NU",
	},
	spoink: {
		tier: "ZU",
	},
	grumpig: {
		tier: "UU",
	},
	spinda: {
		tier: "ZU",
	},
	trapinch: {
		tier: "PU",
	},
	vibrava: {
		tier: "PU",
	},
	flygon: {
		tier: "OU",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		tier: "NU",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		tier: "UU",
	},
	zangoose: {
		tier: "UUBL",
	},
	seviper: {
		tier: "PU",
	},
	lunatone: {
		tier: "UU",
	},
	solrock: {
		tier: "UU",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		tier: "NU",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		tier: "NU",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		tier: "OU",
	},
	lileep: {
		tier: "ZU",
	},
	cradily: {
		tier: "UU",
	},
	anorith: {
		tier: "ZU",
	},
	armaldo: {
		tier: "UUBL",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		tier: "OU",
	},
	castform: {
		tier: "ZU",
	},
	castformsunny: {
	},
	castformrainy: {
	},
	castformsnowy: {
	},
	kecleon: {
		tier: "NU",
	},
	shuppet: {
		tier: "ZU",
	},
	banette: {
		tier: "UU",
	},
	duskull: {
		tier: "PU",
	},
	dusclops: {
		tier: "UUBL",
	},
	tropius: {
		tier: "PU",
	},
	chimecho: {
		tier: "NU",
	},
	absol: {
		tier: "UU",
	},
	snorunt: {
		tier: "ZU",
	},
	glalie: {
		tier: "NU",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "PU",
	},
	walrein: {
		tier: "UU",
	},
	clamperl: {
		tier: "ZU",
	},
	huntail: {
		tier: "NU",
	},
	gorebyss: {
		tier: "UU",
	},
	relicanth: {
		tier: "NU",
	},
	luvdisc: {
		tier: "ZU",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "PU",
	},
	salamence: {
		tier: "OU",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NU",
	},
	metagross: {
		tier: "OU",
	},
	regirock: {
		tier: "UUBL",
	},
	regice: {
		tier: "UUBL",
	},
	registeel: {
		tier: "UUBL",
	},
	latias: {
		tier: "Uber",
	},
	latios: {
		tier: "Uber",
	},
	kyogre: {
		tier: "Uber",
	},
	groudon: {
		tier: "Uber",
	},
	rayquaza: {
		tier: "Uber",
	},
	jirachi: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	deoxys: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	deoxysattack: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	deoxysdefense: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	deoxysspeed: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
};
